import { Component, OnInit } from '@angular/core';
import { UxService } from '~/app/core/services';
import { OutboxBaseComponent } from '~/app/open-age/send-it/components/outbox.base.component';
import { MessageService } from '~/app/open-age/send-it/services';

@Component({
  selector: 'send-it-outbox',
  templateUrl: './outbox.component.html',
  styleUrls: ['./outbox.component.css']
})
export class OutboxComponent extends OutboxBaseComponent {

  constructor(
    service: MessageService,
    uxService: UxService
  ) {
    super(service, uxService);
  }
}
